import { createContext } from 'react';

export const recipeContext = createContext();